import { Routes, Route, BrowserRouter } from "react-router-dom";
import DashboardPage from "../pages/dashboard";
import PrivacyPage from "../pages/privacy";
import UserTermsPage from "../pages/userTerms";
import {
  DeleteAccount,
  Alexa,
  GoogleHome,
  AppleHealth,
  GoogleFit,
  HealthConnect,
} from "../pages/helpCenter";
import DeviceInfoPage from "../pages/deviceInfo";
import { ResetPage, ResetResult } from "../pages/reset";
import LoginPage from "../pages/login";
import {
  ServiceList,
  CompatibleDevice,
  VoiceCommand,
  ServiceConnect,
} from "../pages/thirdParty";
import { ProductManual } from "../pages/product";
import { Download } from "../pages/download";

import { RouterPath } from "./routerPaths";
import { publicPath } from "../request";

import {
  MeterSharePage,
  DetailsPage,
  StatisticsPage,
  HistoryPage,
} from "../pages/meter";

const RoutesPath = () => {
  return (
    <BrowserRouter basename={publicPath}>
      <Routes>
        <Route path={RouterPath.root} element={<LoginPage />} />
        <Route
          path={RouterPath.helpCenterDeleteAccount}
          element={<DeleteAccount />}
        />
        <Route path={RouterPath.home} element={<DashboardPage />} />
        <Route path={RouterPath.helpCenterAlexa} element={<Alexa />} />
        <Route
          path={RouterPath.helpCenterGoogleHome}
          element={<GoogleHome />}
        />
        <Route path={RouterPath.deviceInfo} element={<DeviceInfoPage />} />
        <Route path={RouterPath.login} element={<LoginPage />} />
        <Route path={RouterPath.reset} element={<ResetPage />} />
        <Route path={RouterPath.resetResult} element={<ResetResult />} />
        <Route path={RouterPath.privacy} element={<PrivacyPage />} />
        <Route path={RouterPath.userTerms} element={<UserTermsPage />} />
        <Route path={RouterPath.thirdParty} element={<ServiceList />} />
        <Route
          path={RouterPath.compatibleDevice}
          element={<CompatibleDevice />}
        />
        <Route path={RouterPath.voiceCommand} element={<VoiceCommand />} />
        <Route path={RouterPath.serviceConnect} element={<ServiceConnect />} />
        <Route path={RouterPath.productManual} element={<ProductManual />} />
        <Route path={RouterPath.download} element={<Download />} />
        <Route
          path={RouterPath.helpCenterAppleHealth}
          element={<AppleHealth />}
        />
        <Route path={RouterPath.helpCenterGoogleFit} element={<GoogleFit />} />
        <Route
          path={RouterPath.helpCenterHealthConnect}
          element={<HealthConnect />}
        />
        <Route path={RouterPath.meterDetails} element={<DetailsPage />} />
        <Route path={RouterPath.meterHistory} element={<HistoryPage />} />
        <Route path={RouterPath.meterShare} element={<MeterSharePage />} />
        <Route path={RouterPath.meterStatistics} element={<StatisticsPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesPath;
